import ModuleFavoriteStar from '@/components/common/ModuleFavoriteStar';
import { getIconColors, getModuleIcon } from '@/utils/moduleIcons';

interface SystemModuleCardProps {
  name: string;
  icon?: string;
  title: string;
  description?: string;
  systemName?: string;
  dense?: boolean;
  onOpen: () => void;
}

export default function SystemModuleCard({
  name,
  icon,
  title,
  description,
  systemName,
  dense = false,
  onOpen,
}: SystemModuleCardProps) {
  const colors = getIconColors(icon);
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onOpen();
        }
      }}
      className={`group relative flex h-full cursor-pointer rounded-xl border border-border bg-bgElevated text-left transition-colors duration-200 hover:border-bgPrimary ${
        dense ? 'min-h-[9.5rem] p-4' : 'rounded-lg p-6'
      }`}
    >
      {systemName && (
        <ModuleFavoriteStar systemName={systemName} moduleName={name} className={dense ? 'absolute top-3 right-3' : undefined} />
      )}
      <div className={`flex min-w-0 ${dense ? 'items-start gap-3 pr-7' : 'items-center gap-4 pr-6'}`}>
        <div className={`shrink-0 rounded-lg transition-colors group-hover:bg-bgPrimary group-hover:text-white ${colors.bgClass} ${colors.textClass} ${
          dense ? 'p-2' : 'p-3'
        }`}
        >
          {getModuleIcon(icon, dense ? 'w-6 h-6' : 'w-8 h-8')}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className={`font-semibold leading-snug text-textDefault transition-colors group-hover:text-bgPrimary ${
            dense ? 'text-xl tracking-tight' : 'text-xl'
          }`}
          >
            {title}
          </h3>
          {description && (
            <p className={`text-textSecondary ${dense ? 'mt-1 line-clamp-4 text-base leading-snug' : 'mt-1 text-sm'}`}>
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
